import { render, staticRenderFns } from "./AutomaticRattachmentConfirm.vue?vue&type=template&id=261f56b1"
import script from "./AutomaticRattachmentConfirm.vue?vue&type=script&lang=js"
export * from "./AutomaticRattachmentConfirm.vue?vue&type=script&lang=js"
import style0 from "./AutomaticRattachmentConfirm.vue?vue&type=style&index=0&id=261f56b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports